import { Box, FormControl, FormLabel } from '@chakra-ui/react';
import usePipelineStore from '../../../../stores/pipeline-store';
import { DrawerCheckbox, DrawerInput, VarSelect } from '../inputs';

type StepDrawerCreateDashboardProps = {
    stepId: string;
};

export function CreateDashboardSettings({ stepId }: StepDrawerCreateDashboardProps) {
    const { pipeline, updateStep } = usePipelineStore((state) => state);
    const step = pipeline.steps[stepId] as CreateDashboardStep;

    const updateDashboardStep = (
        objName: keyof CreateDashboardStep,
        fieldName: keyof VarConstValue,
        value: boolean | string | number,
    ) => {
        const newObj = JSON.parse(JSON.stringify(step[objName])) as VarConstValue;
        (newObj[fieldName] as unknown) = value;
        updateStep(stepId, objName, newObj);
    };

    return (
        <Box mx={-3}>
            <FormControl>
                <FormLabel mt={2}>Dashboard resource id</FormLabel>
                <DrawerCheckbox
                    isChecked={step.dashboardResourceId?.isFromVar}
                    onChange={({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) => {
                        updateDashboardStep('dashboardResourceId', 'isFromVar', checked);
                    }}
                >
                    {step.dashboardResourceId?.isFromVar
                        ? 'Dashboard resource id is a var'
                        : 'Dashboard resource id is const'}
                </DrawerCheckbox>
                {!step.dashboardResourceId?.isFromVar && (
                    <DrawerInput
                        mt={2}
                        placeholder="Enter dashboard resource Id"
                        type="text"
                        autoComplete="off"
                        value={step.dashboardResourceId.constValue ? step.dashboardResourceId.constValue : ''}
                        onChange={(e) => updateDashboardStep('dashboardResourceId', 'constValue', e.target.value)}
                    />
                )}
                {step.dashboardResourceId?.isFromVar && (
                    <Box mt={2}>
                        <VarSelect
                            value={step.dashboardResourceId.varId}
                            filterByType={['STRING']}
                            onChange={(value) => updateDashboardStep('dashboardResourceId', 'varId', value)}
                        />
                    </Box>
                )}

                <FormLabel mt={2}>Respondent group name</FormLabel>
                <DrawerCheckbox
                    isChecked={step.respondentGroupName?.isFromVar}
                    onChange={({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) => {
                        updateDashboardStep('respondentGroupName', 'isFromVar', checked);
                    }}
                >
                    {step.respondentGroupName?.isFromVar
                        ? 'Respondent group name is var'
                        : 'Respondent group name is const'}
                </DrawerCheckbox>
                {!step.respondentGroupName?.isFromVar && (
                    <DrawerInput
                        mt={2}
                        placeholder="Enter respondnet group name"
                        type="text"
                        autoComplete="off"
                        value={step.respondentGroupName.constValue ? step.respondentGroupName.constValue : ''}
                        onChange={(e) => updateDashboardStep('respondentGroupName', 'constValue', e.target.value)}
                    />
                )}
                {step.respondentGroupName?.isFromVar && (
                    <VarSelect
                        value={step.respondentGroupName.varId}
                        filterByType={['STRING']}
                        onChange={(value) => updateDashboardStep('respondentGroupName', 'varId', value)}
                    />
                )}

                <FormLabel>Dashboard url target var</FormLabel>
                <VarSelect
                    value={step.dashboardUrlTargetVarId}
                    filterByType={['STRING']}
                    onChange={(value) => updateStep(stepId, 'dashboardUrlTargetVarId', value)}
                />

                <FormLabel>Dashboard ref target var</FormLabel>
                <VarSelect
                    value={step.dashboardRefTargetVarId}
                    filterByType={['REF']}
                    onChange={(value) => updateStep(stepId, 'dashboardRefTargetVarId', value)}
                />
            </FormControl>

            <FormLabel>Dashboard editToken target var</FormLabel>
            <VarSelect
                value={step.dashboardEditTokenTargetVarId}
                filterByType={['STRING']}
                onChange={(value) => updateStep(stepId, 'dashboardEditTokenTargetVarId', value)}
            />
        </Box>
    );
}
